<template>
  <tr @click="toggleSelf" style="cursor: pointer">
    <td style="padding-left: 120px">
      {{ data.name }}
    </td>
    <td></td>
    <td>{{ usNum(data.apps)}}</td>
    <td></td>
    <td>{{ money(data.spend)}}</td>
    <td></td>
    <td></td>
    <td></td>
    <td></td>
      <td></td>
    <td></td>
  </tr>
</template>

<script>
export default {
  props: [
    'data'
  ],
  data() {
    return {
    };
  },
  methods: {
    toggleSelf() {
      this.data.is_open = !this.data.is_open;
    }
  }
}
</script>

<style>
</style>
